"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandCollapseButton = void 0;
const react_1 = __importDefault(require("react"));
// this is temporary while work on EN-3049 is in progress
// when EN-3049 is complete, files in the v2 folder will replace the existing side-bar files
const sidebar_section_styles_1 = require("../sidebar-section.styles");
const icons_1 = require("../../../../../../icons");
const ExpandCollapseButton = ({ isExpanded, toggleExpandState, }) => (react_1.default.createElement(sidebar_section_styles_1.StyledIconButton, { onClick: toggleExpandState }, isExpanded ? react_1.default.createElement(icons_1.CollapseArrowsIcon, null) : react_1.default.createElement(icons_1.ExpandArrowsIcon, null)));
exports.ExpandCollapseButton = ExpandCollapseButton;
exports.default = exports.ExpandCollapseButton;
